<template>
	<div class="tab-view">
		<div :class="{
			tab: 	true,
			active: value == tab.value
		}" v-for="(tab, i) in tabs" :key="i" @click.stop="$emit('input', tab.value)">{{ tab.label }}</div>
	</div>
</template>

<script>
	export default {
		props: {
			tabs: {
				type: Array,
				default() {
					return [];
				}
			},
			value: {
				type: String,
				required: true
			}
		}
	}
</script>

<style lang="scss" scoped>
	.tab-view {
		& > .tab {
			display: inline-block;
			padding: 0 10px 0 10px;
			line-height: 40px;
			cursor: pointer;
			
			&.active {
				border-bottom: 3px solid #ff5723;
			}
		}

		margin-bottom: 20px;
	}
</style>